
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const StudentSkeletonCard = () => {
  return (
    <Card className="w-full max-w-md shadow-card">
      <CardHeader className="flex flex-row items-center gap-4 pb-2">
        <Skeleton className="w-16 h-16 rounded-full" />
        <div className="flex-1">
          <Skeleton className="h-6 w-3/4 mb-2" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
        </div>
        
        <div className="space-y-2">
          <Skeleton className="h-4 w-1/3" />
          <div className="space-y-2">
            <Skeleton className="h-16 w-full rounded-md" />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2">
          <Skeleton className="h-14 rounded" />
          <Skeleton className="h-14 rounded" />
          <Skeleton className="h-14 rounded" />
        </div>

        <div className="flex gap-2 mt-4 pt-2">
          <Skeleton className="h-9 w-full rounded" />
          <Skeleton className="h-9 w-10 rounded" />
          <Skeleton className="h-9 w-10 rounded" />
        </div>
      </CardContent>
    </Card>
  );
};
